import {Injectable} from "@angular/core";

@Injectable()
export class ArchiveWindowService {
  currentActiveTab = "chats";
  tabs = [
    {
      label: "CHATS",
      active: true,
      value: "chats"
    },
    {
      label: "CHANNELS",
      active: false,
      value: "channels"
    },
    {
      label: "TOPICS",
      active: false,
      value: "topics"
    }
  ];
  constructor() {
  }


  changeTab(val: string) {
    this.tabs.forEach(tab => {
      tab.active = tab.value === val;
    });
    this.currentActiveTab = val;
  }
}
